export const AddHandler = (props) => {
  const { onAdd, label, dogSignUp = false } = props || {};

  return (
    <button className={!dogSignUp ? "w-full" : ""} onClick={onAdd}>
      <div
        className="flex flex-row justify-end"
      >
        <span className="text-base font-semibold text-primary mr-2">
          {label}
        </span>
      </div>
    </button>
  );
};
